import React, { useState } from 'react';
import Arrow from './../../images/icons/arrowLeft.svg';
import {
    EarningsArrow,
    EarningsItem,
    EarningsItemsWrapper,
    EarningsTop,
    EarningsWrapper,
} from './styled';
import Text from '../../ui/Text';
import { formatDenmarkCurrency } from '../../utils/UiHelper';

const defaultValues = [
    '1 - Over',
    '1 - Under',
    'X - Over',
    'X - Under',
    '2 - Over',
    '2 - Under',
];

const Big9PotentialEarnings = ({ earnings, isResultPage, ongoingEvent }) => {
    const [isOpen, setIsOpen] = useState(false);
    const getItems = (items) => {
        if (items.possibleOutcomes) {
            return items.possibleOutcomes.map((value, key) => {
                return (
                    <EarningsItem
                        key={key}
                        bg={key % 2 ? 'transparent' : '#f5f7fc'}
                    >
                        <Text
                            width={'50%'}
                            size={'14'}
                            lh={'14'}
                            bold
                            margin={'0'}
                            padding={'0'}
                            color={'#333'}
                        >
                            {value.outcome.includes('/O')
                                ? value.outcome.replace('/O', ' - Over')
                                : value.outcome.replace('/U', ' - Under')}
                        </Text>
                        <Text
                            width={'50%'}
                            size={'14'}
                            lh={'14'}
                            bold
                            margin={'0'}
                            padding={'0'}
                            color={'#333'}
                            align={'right'}
                        >
                            {value.pool9unitDividend === 0
                                ? '0 kr.'
                                : `${formatDenmarkCurrency(
                                      value.pool9unitDividend / 100
                                  )} kr.`}
                        </Text>
                    </EarningsItem>
                );
            });
        }
    };

    return (
        <EarningsWrapper className={isResultPage ? 'isResultPage' : null}>
            <EarningsTop onClick={() => setIsOpen(!isOpen)}>
                <Text
                    size={'16'}
                    lh={'18'}
                    color={'#fff'}
                    margin={'0'}
                    padding={'0'}
                    bold
                >
                    Mulige gevinster ved 9 rigtige
                </Text>
                <EarningsArrow
                    src={Arrow}
                    className={isOpen ? 'active' : null}
                />
            </EarningsTop>
            <EarningsItemsWrapper height={isOpen ? 'auto' : '0'}>
                {Object.keys(ongoingEvent).length > 0 && (
                    <Text
                        width={'100%'}
                        size={'14'}
                        lh={'14'}
                        bold
                        margin={'0'}
                        padding={'0 20px 15px'}
                        color={'#333'}
                        align={'left'}
                    >
                        {`${ongoingEvent.name} - ${ongoingEvent.startTime}`}
                    </Text>
                )}

                {getItems(earnings)}
            </EarningsItemsWrapper>
        </EarningsWrapper>
    );
};

export default Big9PotentialEarnings;
